'use client';

import { addClassName } from '@hc-frontend/core-utils-format';
import type { MouseEventHandler } from 'react';

import type { TypAdCardProps } from './typ-ad-card.types';

export function TypAdCardVariant({
  children,
  onClick,
  linkDataAttribute,
  className,
  ...props
}: TypAdCardProps) {
  const handleClick: MouseEventHandler<HTMLDivElement> = (e) => {
    const link = e.currentTarget.querySelector<HTMLAnchorElement>(
      `[${linkDataAttribute}]`,
    );
    link?.click();
    onClick?.(e);
  };

  return (
    <div
      role="link"
      onClick={handleClick}
      className={addClassName(
        'border-[#0083E1] border-[0.5px] hover:scale-[1.01] transition-transform cursor-pointer rounded-lg p-24-32 bg-gray-0 shadow-card overflow-hidden',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
